<template>
  <div>
    <div v-if="list.length !== 0" class="barcode-scanner__products-list" :style="formattedStyles">
      <div class="barcode-scanner__products-list_item d-flex"
           v-for="item in list"
           :key="item.id"
      >
        <div class="d-flex barcode-scanner__products-list_div">
          <div class="col-lg-8 my-2 p-0 col-10">
            <div class="d-flex">
              <div class="photoContainer">
                <img class="photo" :src="item.photoUrl || '/assets/braun_image.png'" alt="Braun product"/>
              </div>
              <div class="item-content d-flex">
                <div class="name">{{item.name}}</div>
                <div class="ean">EAN: {{item.ean}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div  v-if="showReturnBackButton && list.length === 0" :style="formattedGridStyles" style="justify-content: center; display:flex">
      <buttonComponent
        addClass="btn next-btn"
        @click.native="goToSelectProducts()"
        :textColor="white"
        text="Produkte hinzufügen"
        backgroundColor="var(--color2)"
        borderColor="var(--color2)"
        :borderRadius='"50rem"'
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import buttonComponent from "@/components/renderers/button-component.vue";
import { BInputGroup, BButton } from 'bootstrap-vue-next';
import { X } from 'lucide-vue-next'

export default {
  name: 'productsList',
  components: {
    buttonComponent,
    BInputGroup,
    BButton,
    X
  },
  props: {
    styles: {
      type: Object,
      required: false
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    showReturnBackButton: {
      type: Boolean,
      default: false
    },
    maxProductCount: Number
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      list: state => state.scannedProducts
    }),
    formattedStyles () {
      if (!this.styles) return '';
      return Object.entries(this.styles)
        .map(([key, value]) => `${key}:${value};`)
        .join('');
    },
    formattedGridStyles () {
      if (!this.grid) return 'justify-content: center; display:flex';
      return Object.entries(this.grid)
        .map(([key, value]) => `${key}:${value};`)
        .join('') + 'justify-content: center; display:flex';
    }
  },
  methods: {
    ...mapActions(["removeProduct", "editQuantityProduct", "editInputQuantityProduct"]),
    editProduct (product, action) {
      let data = { product, action, maxProductCount: this.maxProductCount };
      this.editQuantityProduct(data);
      if (!product.count) {
        this.removeProduct(product.id);
      }
    },
    goToSelectProducts () {
      this.goToPage({
        pageName: 'productSelection',
        shouldBack: true
      }, this)
    }
  },
  watch: {
    list: {
      immediate: true,
      handler (val){
        if(val){
          this.$eventHub.emit('scrollToProductList')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.spin-btn {
  width: 25px;
  height: 25px;
  color: #fff;
  background: linear-gradient(45deg, var(--button-gradient-4) 0%, var(--button-gradient-3) 100%) !important;
  border: none;
  border-radius: 4px;
  &:hover {
    background: linear-gradient(45deg, var(--button-gradient-4) 0%, var(--button-gradient-3) 100%) !important;
  }
}
.barcode-scanner__products-list {
  width: 100%;

  @media (max-width: 767px) {
    padding: 0;
  }
  &_item {
    background: #FFFFFF;
    border: 1px solid #6BB1FF;
    box-sizing: border-box;
    border-radius: 16px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 32px;
    @media (max-width: 991px) {
      padding: 16px !important;
    }
    div {
      align-items: center;
    }
    .photoContainer {
      margin-right: 10px;

      &::after {
        content: '';
        position: absolute;
        left: 8px;
        bottom: -5px;
        width: 40px;
        height: 5px;
        background: rgba(196, 196, 196, 0.51);
        filter: blur(5px);
      }
    }
    .photo {
      max-width: 56px;
      max-height: 56px;
    }

    .item-content {
      flex-direction: column;
      align-items: flex-start;

      letter-spacing: 0px;
      color: #000000;


      .name {
        font: normal normal 600 14px/18px 'Plus Jakarta Sans';
        margin-bottom: 5px;
      }

      .ean {
        font: normal normal 500 14px/18px 'Plus Jakarta Sans';
      }
    }
  }
  &_div{
    width: 100%;
    @media (max-width: 517px) {
      width: 90%;
    }
  }
  .circle {
    display: flex;
    width: 44px;
    height: 44px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    background-color: #9ADFE6;
    border-radius: 2em;
  }
}

.select-none {
  user-select: none;
}

.short-logo {
  width: 36px;
}

.btn-info {
  width: 44px;
  height: 44px;
  border-radius: 100% !important;
  font-size: 0;
  line-height: 1;
  background-color: var(--color9);
  border: 0;
  .input-group-prepend &{
    background-image: url("../../assets/icons/minus.svg");
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .input-group-append &{
    background-image: url("../../assets/icons/plus.svg");
    background-size: 50%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.btn-danger {
  background: 0;
  border: 0;
  border-radius: 0;
  color: #6F6F6F;
  &:focus {
    outline: 0 !important;
    box-shadow: none;
  }
}
.btn-edit {
  background: 0;
  border: 0;
  &:focus {
    outline: 0 !important;
    box-shadow: none;
  }
}
</style>
